import { json } from "@codemirror/lang-json";
import { yaml } from "@codemirror/lang-yaml";
import { githubDark } from "@uiw/codemirror-theme-github";
import { useCodeMirror } from "@uiw/react-codemirror";
import { type FC, useEffect, useRef } from "react";

const extensions = {
  json: [json()],
  yaml: [yaml()],
};

export interface CodeEditorProps {
  language: "yaml" | "json";
  value: string;
  onChange?: (value: string) => void;
  editable?: boolean;
  className?: string;
}

export const CodeEditor: FC<CodeEditorProps> = props => {
  const { language, value, className, onChange, editable = true } = props;
  const editor = useRef<HTMLDivElement>(null);

  const { setContainer } = useCodeMirror({
    container: editor.current,
    extensions: extensions[language],
    value,
    theme: githubDark,
    readOnly: !editable,
    onChange: v => onChange?.(v),
    basicSetup: {
      searchKeymap: true,
    },
  });

  useEffect(() => {
    if (editor.current) {
      setContainer(editor.current);
    }
  }, [setContainer]);

  return <div ref={editor} className={className} />;
};
